// extracted by mini-css-extract-plugin
export var messageSideLeft = "_no-1";
export var messageSideRight = "_no-2";
export var orderLookupBubbleContainer = "_no-0";
export var submitButton = "_no-3";